export const PITCH_LIMITS = {
  MIN: 0,
  MAX: 36,
};

export const isPitchValueValid = (pitch) => Number(pitch) >= PITCH_LIMITS.MIN && Number(pitch) <= PITCH_LIMITS.MAX;
export const EDIT_PITCH_ZOOM_LIMITS = {
  MIN: 1,
  MAX: 2,
};

export const PITCH_VALUE_REGEX = /^\d+(?:\.\d)?$/;

export const ZOOM_STEP = 0.05;
